import { createSelector, select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { appConfigSelector } from './app-config.selectors';

// collect all selectors to manage state required before app initiation
const appInitSelector = createSelector(
  appConfigSelector,
  (appConfig) => appConfig != null,
);

export const selectTriggerAppInit = pipe(
  select(appInitSelector),
  filter((toInitApp: boolean) => toInitApp),
  take(1),
);
